import React from "react";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { AuthenticatedResponse } from "../store/Interfaces";
import LoadingModal from "./LoadingModal";
import { Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";


export default class LoginForm extends React.Component {
  public state: {
    isLoading: boolean,
    isError: boolean,
    isSystemError: boolean,
    captchatoken: string | undefined,
    refreshReCaptcha: boolean | undefined,
  }

  constructor(props: {}) {
    super(props);
    this.state = {
      isLoading: false,
      isError: false,
      isSystemError: false,
      captchatoken: undefined,
      refreshReCaptcha: undefined,
    };
  }

  handleValidSubmit = (event: any, values: {
    username: string;
    password: string;
    captchatoken: string;
  }) => {

    this.setState({
      isLoading: true,
    });

    if (this.state.captchatoken) {

      values.captchatoken = this.state.captchatoken;

      this.setState({
        isLoading: true,
        refreshReCaptcha: !this.state.refreshReCaptcha
      });
      fetch(
        process.env.REACT_APP_API_HOST +
        `/Authenticate/login`,
        {
          method: "POST",
          // credentials: "include",
          body: JSON.stringify(values),
          headers: {
            pragma: "no-cache",
            "cache-control": "no-cache",
            "content-type": "application/json",
          },
        }
      )
        .then((response) => {
          if (!response.ok) {

            this.catchNok(response);



          } else {


            return response.json() as Promise<AuthenticatedResponse | Array<{result?: string}>>;


          }
        })
        .then((data) => {
          if (data) {
            if (Array.isArray(data) && data[0] && data[0].result && data[0].result === "Invalid Password") {
              this.setState({
                isLoading: false,
                isError: true,
                isSystemError: false,
                refreshReCaptcha: !this.state.refreshReCaptcha,
              });
            } else if (!Array.isArray(data)) {
              this.setState({
                isLoading: false,
                isError: false,
                isSystemError: false,
                refreshReCaptcha: !this.state.refreshReCaptcha,
              });
              const accessToken = (data as AuthenticatedResponse).accessToken;
              const refreshToken = (data as AuthenticatedResponse).refreshToken;
              localStorage.setItem("accessToken", accessToken);
              localStorage.setItem("refreshToken", refreshToken);
              window.location.href = "/cabsbillportal/";
            } else {
              this.catchError('Invalid Response');
            }
          } else {
            this.catchError('Invalid Response');
          }
        })
        .catch((error) => {
          this.catchError(error);

        });
    } else {
      setTimeout(() => {
        this.handleValidSubmit(event, values);
      }
        , 500)

    }

  };

  public catchError(error: any) {
    this.setState({
      bans: [],
      isLoading: false,
      isError: true,
      isSystemError: true,
      refreshReCaptcha: !this.state.refreshReCaptcha,
    });
    // console.log(error);

  }
  public catchNok(response: Response) {
    this.setState({
      bans: [],
      isLoading: false,
      isError: true,
      isSystemError: false,
      refreshReCaptcha: !this.state.refreshReCaptcha,
    });

  }
  handleInvalidSubmit = (event: any, errors: any) => {

    // console.log(errors);
  };

  public componentDidMount() {
    this.ensureDataFetched();
    // if(this.state.refreshReCaptcha === undefined)
    // {
    //   this.setState({
    //     refreshReCaptcha: false
    //   });
    // }
  }

  private ensureDataFetched() {

  }

  componentDidUpdate() {
    // this.setState({
    //   refreshReCaptcha: !this.state.refreshReCaptcha,
    // });
  }
  render() {

    return (

      <AvForm
        onValidSubmit={this.handleValidSubmit}
        onInvalidSubmit={this.handleInvalidSubmit}
      >
        {this.state.isSystemError === true && <Alert color="danger">There was a system error.  Please try again or if the issue persists please send email to <a href="mailto:CABSBill_Inquiry@ftr.com">CABSBill_Inquiry@ftr.com</a>. </Alert>}
        {this.state.isSystemError === false && this.state.isError === true && <Alert color="danger">You've entered an invalid username or password. </Alert>}

        <AvField
          name="username"
          label="Username"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter your username"
            },
          }}
        />
        <AvField
          name="password"
          label="Password"
          type="password"
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter your password"
            }
          }}
        />
        <div className="d-flex flex-wrap flex-row justify-content-between">
          <div className="d-flex flex-col">
            <button className="btn btn-inverse btn-primary btn-sm" id="submit"><strong>Sign In</strong></button>
          </div>
          <div className="d-flex flex-col">
            <em><a href="/cabsbillportal/welcome">
              {/* <Link onClick={() => { window.location.href = "/cabsbillportal/welcome" }} to="/Welcome"> */}
              Forgot Password
            </a></em>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between">
          <div className="d-flex flex-col">
            <em>For assistance signing in to your account, please send email to <a href="mailto:CABSBill_Inquiry@ftr.com">CABSBill_Inquiry@ftr.com</a>.</em>
          </div>

        </div>
        <hr></hr>
        <div className="d-flex flex-row justify-content-between">
          <div className="d-flex flex-col">
            <em>To request access to the Frontier CABS Bill Portal, please click on REGISTER.</em>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between">

          <div className="d-flex flex-col">
            <button className="btn btn-inverse btn-secondary btn-sm" id="reg" onClick={() => { window.location.href = "/cabsbillportal/registration" }}><strong>Register</strong></button>

          </div>
          <div className="d-flex flex-col">
            <GoogleReCaptcha
              refreshReCaptcha={this.state.refreshReCaptcha}
              onVerify={(token) => {
                this.setState({ captchatoken: token })
              }}
            />
            <div id="recaptchaform"></div>
          </div>
        </div>


        <LoadingModal isLoading={this.state.isLoading}></LoadingModal>
      </AvForm>
    );
  }
}
